import React from 'react';
import { Form } from 'semantic-ui-react';
import { DatePicker } from '@components/shared/DatePicker';
import CheckboxWrapper from '@components/shared/Checkbox';
import HotelsDropDown from '@components/shared/HotelsDropDown';
import RoomTypesDropDown from '@components/shared/RoomTypesDropDown';
import CustomerDropDown from '@components/shared/CustomerDropDown';
import RatesDropDown from '@components/shared/RatesDropDown';
import ProductsDropDown from '@components/shared/ProductsDropDown';

// SearchPanel expects a flat array of keyed fields, so this returns elements rather than a component.
export const buildFilterFields = ({ text, testId, hotelIds, roomTypeIds, rateIds, roomTypesSpec, ratesSpec, productsSpec, customersProps, setHotelIds, setRoomTypeIds, setRateIds }) => [
    <Form.Field
        key='HotelIds'
        label={text('Hotels')}
        control={HotelsDropDown}
        onChange={(ids) => setHotelIds(ids || [])}
        placeholder={text('SelectHotel')}
        multiple
        clearable
        required
        data-testId={`${testId}.hotel`}
    />,
    <Form.Field
        key='RoomTypeIds'
        label={text('RoomTypes')}
        control={RoomTypesDropDown}
        onChange={(ids) => setRoomTypeIds(ids || [])}
        spec={roomTypesSpec}
        disabled={!hotelIds.length}
        placeholder={text('All')}
        multiple
        clearable
        search
        data-testId={`${testId}.roomType`}
    />,
    <Form.Field
        key='RateIds'
        label={text('Rates')}
        control={RatesDropDown}
        onChange={(ids) => setRateIds(ids || [])}
        HotelIds={hotelIds}
        spec={ratesSpec}
        disabled={!hotelIds.length}
        placeholder={text('All')}
        multiple
        clearable
        search
        data-testId={`${testId}.rate`}
    />,
    <Form.Field
        key='CustomerIds'
        label={text('Customers')}
        control={CustomerDropDown}
        spec={customersProps?.spec}
        data={customersProps?.data}
        placeholder={text('All')}
        multiple
        clearable
        search
        data-testId={`${testId}.customer`}
    />,
    <Form.Field
        key='ProductIds'
        label={text('Products')}
        control={ProductsDropDown}
        spec={productsSpec}
        descriptionField='RateName'
        disabled={!roomTypeIds.length || !rateIds.length}
        placeholder={text('All')}
        multiple
        clearable
        search
        data-testId={`${testId}.product`}
    />,
    <Form.Field key='Empty1' />,
    <Form.Field key='Empty2' />,
    <Form.Field key='Empty3' />,
    <DatePicker
        key='FromToDates'
        picktype='range'
        label={text('Date')}
        clearable={false}
        required
        data-testId={`${testId}.date`}
    />,
    <DatePicker
        key='CreateFromToDates'
        picktype='range'
        label={text('CreateDate')}
        clearable
        data-testId={`${testId}.createDate`}
    />,
    <CheckboxWrapper
        key='IncludeInactive'
        label={text('IncludeInactive')}
        data-testId={`${testId}.includeInactive`}
    />,
    <CheckboxWrapper
        key='Inclusive'
        label={text('Inclusive')}
        data-testId={`${testId}.inclusive`}
    />,
];
